import {useState, createContext, useContext} from 'react';
import {useParams} from 'react-router-dom';
import {initializeExternalWallet} from 'api/routes/wallet';
import {getError, openLink} from 'utils/helpers';

export const STEPS = {
    PHONE_VERIFICATION: 'Phone',
    WAITING_FOR_PAYMENT: 'WaitingForPayment',
    FAILED: 'FAILED',
};

export const PayWithPalmpayContext = createContext({});
export const usePayWithPalmpay = () => useContext(PayWithPalmpayContext);

export const PayWithPalmpayProvider = ({checkoutData = {}, children}) => {
    const [authorizationUrl, setAuthorizationUrl] = useState();
    const [currentState, setCurrentState] = useState(STEPS.PHONE_VERIFICATION);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [formErrors, setFormErrors] = useState({});
    const [phone_number, setPhoneNumber] = useState('');

    const {reference} = useParams();

    const {metadata, API, apiVersion} = checkoutData;
    const Authorization = metadata?.merchant?.publicKey;
    const config = {headers: {Authorization}};

    const updateCurrentState = newState => {
        setLoading(false);
        setErrorMsg('');
        setCurrentState(newState);
    };

    const handleChange = phone => {
        setPhoneNumber(phone);
        updateError('phone_number');
    };

    const updateError = name => {
        setFormErrors(prev => ({
            ...prev,
            [name]: '',
        }));
    };

    const handleError = message => {
        setLoading(false);
        setErrorMsg({msg: message});
    };

    const handlePhone = async () => {
        try {
            setLoading(true);
            setErrorMsg();

            const origin = window?.location?.origin;
            const callbackUrl = `${origin}/transaction/done`;

            const response = await API.post(
                `${apiVersion}${initializeExternalWallet(reference, 'palmpay')}`,
                {phone_number, callbackUrl},
                config
            );

            const {status, data} = response || {};

            if ((status === 201 || status === 200) && (data.status || data.success)) {
                openLink(data?.data, '_blank', true);
                updateCurrentState(STEPS.WAITING_FOR_PAYMENT);
            } else handleError(data?.message);
        } catch (error) {
            handleError(getError(error?.response?.data));
        }
    };

    return (
        <PayWithPalmpayContext.Provider
            value={{
                currentState,
                loading,
                errorMsg,
                formErrors,
                phone_number,
                handleChange,
                handlePhone,
                updateCurrentState,
                setAuthorizationUrl,
                authorizationUrl,
            }}
        >
            {children}
        </PayWithPalmpayContext.Provider>
    );
};
